import { axiosInstance } from './api';

/** Лента последних предсказаний по филиалу, «Служебные» (#2137). */
export interface FeedShelf { name: string; pct: number; thr: number }
export interface FeedItem {
  kind: 'layout' | 'tables';
  id: string;
  at: string;
  camera_id: number | null;
  name: string;
  verdict: string | null;
  score?: number;
  shelves?: FeedShelf[];
  scores?: Record<string, number> | null;
  polygons: number[][][] | null;
  image_url: string | null;
  image_kind: 'frame' | 'crop' | null;
}
export interface FeedPage { items: FeedItem[]; next: string | null }

export const getPredictionsFeed = (zoneId: string, kinds: string, before?: string | null, limit = 40) =>
  axiosInstance.get<FeedPage>('/core/api/service/predictions-feed/', {
    params: { zone_id: zoneId, kinds, before: before ?? undefined, limit },
  });
